import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  ContentProvider,
  PageContainer,
  PageHeader,
  PageLead,
} from '../content/components';
import { ContentSection } from '../layout/components';

import {
  CrossLinksSection,
  LinkList,
  PotentialColleaguesSection,
  NewsLetterBlock,
} from './components';

class CareersSubPage extends Component {
  static propTypes = {
    breakpoint: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
  };

  render() {
    const { category } = this.props;
    return (
      <ContentProvider
        slug={`careers/${category}`}
        render={({
          header,
          intro,
          primary,
          default_open_positions_link,
          open_positions_link,
          open_positions_list,
          cross_links,
          team_mates,
          newsletter_text,
        }) => (
          <PageContainer>
            <PageHeader mainImage={header.main_image} />
            <PageLead
              title={header.title}
              subtitle={header.subtitle}
              content={intro.content}
              links={intro.links}
              supportImage={
                header.support_media_format === 'circular'
                  ? header.support_image_circular
                  : header.support_image_portrait
              }
              supportVideo={header.support_video}
              supportMediaType={header.support_media_type}
              supportIsCircular={header.support_media_format === 'circular'}
            />

            {/*{open_positions_list && open_positions_list.length > 0 ? (*/}
            {/*  <ContentSection title={`open positions in ${category}`}>*/}
            {/*    <LinkList*/}
            {/*      items={open_positions_list.map(position => ({*/}
            {/*        href: `/careers/${category}/${position.slug}`,*/}
            {/*        label: position.title,*/}
            {/*      }))}*/}
            {/*    />*/}
            {/*  </ContentSection>*/}
            {/*) : (*/}
            {/*  <ContentSection title={`open positions in ${category}`}>*/}
            {/*    <p*/}
            {/*      style={{*/}
            {/*        margin: '0 auto 1.6em',*/}
            {/*        maxWidth: '520px',*/}
            {/*        textAlign: 'center',*/}
            {/*      }}*/}
            {/*    >We currently have no open positions.</p>*/}
            {/*  </ContentSection>*/}
            {/*)}*/}
            {team_mates && (
              <PotentialColleaguesSection colleagues={team_mates} />
            )}

            {newsletter_text && <NewsLetterBlock text={newsletter_text} />}

            {cross_links && <CrossLinksSection crossLinks={cross_links} />}
          </PageContainer>
        )}
      />
    );
  }
}

const mapStateToProps = (state, { match: { params } }) => {
  const { category } = params;
  const { breakpoint } = state.layout;
  return {
    breakpoint,
    category,
  };
};

export default withRouter(connect(mapStateToProps, null)(CareersSubPage));



// WEBPACK FOOTER //
// ./src/modules/pages/CareersSubPage.js